import { useSiteSettings } from "../../../contexts/SiteSettingsContext";
import type { SaleItemData } from "../../../types/settings";
import ImageUploadField from "./ImageUploadField";

export default function SaleTab() {
  const { settings, updateSettings } = useSiteSettings();

  const updateItem = (idx: number, patch: Partial<SaleItemData>) => {
    const items = settings.saleItems.map((s, i) => (i === idx ? { ...s, ...patch } : s));
    updateSettings({ saleItems: items });
  };

  const removeItem = (idx: number) => {
    updateSettings({ saleItems: settings.saleItems.filter((_, i) => i !== idx) });
  };

  const addItem = () => {
    const newItem: SaleItemData = {
      label: "【新しいセール】",
      href: "https://",
      img: "",
      recommend: "",
      hint: "",
      priority: "C",
    };
    updateSettings({ saleItems: [...settings.saleItems, newItem] });
  };

  return (
    <div>
      <h3 className="text-sm font-bold text-gray-700 mb-4 pb-2 border-b border-gray-200">セール情報設定</h3>

      <div className="mb-4">
        <label className="block text-xs font-medium text-gray-600 mb-1">「さらなるセール情報」リンクURL</label>
        <input
          type="url"
          value={settings.saleMoreHref}
          onChange={(e) => updateSettings({ saleMoreHref: e.target.value })}
          className="w-full border border-gray-200 rounded-md px-3 py-2 text-sm focus:outline-none focus:border-red-400"
        />
      </div>

      <div className="space-y-4">
        {settings.saleItems.map((sale, i) => (
          <div key={i} className="border border-gray-200 rounded-lg p-4 space-y-3">
            <div className="flex items-center justify-between">
              <span className="text-xs font-bold text-gray-500">セール {i + 1}</span>
              <button
                onClick={() => removeItem(i)}
                className="text-xs text-red-400 hover:text-red-600 cursor-pointer flex items-center gap-1"
              >
                <i className="ri-delete-bin-line" /> 削除
              </button>
            </div>
            <div>
              <label className="block text-xs text-gray-500 mb-0.5">ラベル（例：【春のセール30%OFF】）</label>
              <input
                type="text"
                value={sale.label}
                onChange={(e) => updateItem(i, { label: e.target.value })}
                className="w-full border border-gray-200 rounded px-2 py-1.5 text-sm focus:outline-none focus:border-red-400"
              />
            </div>
            <div>
              <label className="block text-xs text-gray-500 mb-0.5">リンクURL</label>
              <input
                type="url"
                value={sale.href}
                onChange={(e) => updateItem(i, { href: e.target.value })}
                className="w-full border border-gray-200 rounded px-2 py-1.5 text-sm focus:outline-none focus:border-red-400"
              />
            </div>
            <div>
              <ImageUploadField
                label="バナー画像（URLまたはアップロード）"
                value={sale.img}
                onChange={(url) => updateItem(i, { img: url })}
                placeholder="https://example.com/banner.jpg"
                previewClassName="h-24 w-full object-cover rounded-md"
              />
            </div>
            <div className="flex gap-2">
              <div className="flex-1">
                <label className="block text-xs text-gray-500 mb-0.5">オススメ作品</label>
                <input
                  type="text"
                  value={sale.recommend}
                  onChange={(e) => updateItem(i, { recommend: e.target.value })}
                  className="w-full border border-gray-200 rounded px-2 py-1.5 text-sm focus:outline-none focus:border-red-400"
                />
              </div>
              <div className="w-24">
                <label className="block text-xs text-gray-500 mb-0.5">優先度</label>
                <select
                  value={sale.priority}
                  onChange={(e) => updateItem(i, { priority: e.target.value })}
                  className="w-full border border-gray-200 rounded px-2 py-1.5 text-sm focus:outline-none focus:border-red-400"
                >
                  <option value="S">S</option>
                  <option value="A">A</option>
                  <option value="B">B</option>
                  <option value="C">C</option>
                </select>
              </div>
            </div>
            <div>
              <label className="block text-xs text-gray-500 mb-0.5">ヒント</label>
              <input
                type="text"
                value={sale.hint}
                onChange={(e) => updateItem(i, { hint: e.target.value })}
                className="w-full border border-gray-200 rounded px-2 py-1.5 text-sm focus:outline-none focus:border-red-400"
              />
            </div>
          </div>
        ))}
      </div>

      <button
        onClick={addItem}
        className="mt-4 w-full flex items-center justify-center gap-2 px-4 py-2 border border-dashed border-red-400 rounded-lg text-sm text-red-600 hover:bg-red-50 cursor-pointer"
      >
        <i className="ri-add-line" /> セール情報を追加
      </button>
    </div>
  );
}
